// extracted by mini-css-extract-plugin
var _1 = "DocFlowMappingWidgetMappingFields-modulegroupFields__DJq4Z";
var _2 = "DocFlowMappingWidgetMappingFields-moduleincludeArchivedField__jsvwp";
var _3 = "DocFlowMappingWidgetMappingFields-moduleincludeArchivedInfoIcon__JJMam IconNG-moduleiconContainer__SxWZ0";
export { _1 as "groupFields", _2 as "includeArchivedField", _3 as "includeArchivedInfoIcon" }
